<bs-digital-balance-header [inColumn]="inColumn" />
<div class="betslip-result-content" *ngIf="!isPlatformError; else platformErrorView">
    <bs-digital-linear-result-header />
    <bs-digital-linear-result-slips [succeededSlips]="succeededSlips" [oddsDisplayFormat]="oddsDisplayFormat" [inColumn]="inColumn" />

    <div class="arc-betslip-message" *ngIf="hasArcPostBetMessage$ | async">
        <ms-arc-message [profileData]="profileDetails$ | async" [featureLocation]="FeatureLocation.PostBetSlipMessage" />
    </div>
    <bs-digital-over-ask-stakechange-confirmation *ngIf="showStakeChangeBanner" />
    <bs-digital-over-ask-maxstake-settings *ngIf="showStakeSettingMsg" />
    <!-- <bs-digital-result-failed [oddsDisplayFormat]="oddsDisplayFormat"> </bs-digital-result-failed> -->
</div>
<bs-linear-result-summary [inColumn]="inColumn" />
<ng-template #platformErrorView>
    <div class="note"><i [ngClass]="'theme-error-i warning-color'"></i><span [innerHTML]="platformErrorMessage"></span></div>
</ng-template>
